import React from "react";
import { ArrowLeft, LockKeyhole, MailCheck, ShieldCheck } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import VerifyForm from "./forms/VerifyForm";
import "./auth.scss";

const Verify = () => {
  const navigate = useNavigate();

  return (
    <main className="verify-page">
      <Link className="verify-page__brand" to="/">
        <img src="/images/teleport-now-color-logo.png" alt="Teleport Now" />
      </Link>
      <section className="verify-page__shell">
        <aside className="verify-page__aside">
          <span className="verify-page__aside-icon"><ShieldCheck aria-hidden="true" /></span>
          <p>Account security</p>
          <h1>One quick check, then you&apos;re ready to travel.</h1>
          <ul>
            <li><MailCheck aria-hidden="true" /> Confirm the email used for this account</li>
            <li><LockKeyhole aria-hidden="true" /> Keep bookings and rewards protected</li>
          </ul>
        </aside>
        <div className="verify-page__panel">
          <Link className="verify-page__back" to="/register"><ArrowLeft aria-hidden="true" /> Back</Link>
          <VerifyForm onLoginSuccess={() => navigate("/")} />
        </div>
      </section>
    </main>
  );
};

export default Verify;
